import { render } from "react-dom";
import { CandidateList } from "./CandidateList";
import { Candidate, ElectionType, ListName } from "./types";
import { getTranslations } from "components/site-search/utils";

(() => {
  const candidateListContainers =
    document.querySelectorAll<HTMLDivElement>(".candidate-list");

  candidateListContainers.forEach((candidateListContainer) => {
    const {
      electionTypes,
      electionTypesPostElection,
      listNames,
      selectedElectionType: selectedElectionTypeValue,
      selectedListName: selectedListNameValue,
      showAllCandidates,
      initialCandidatesList,
      showElectedCandidatesOnly,
    } = candidateListContainer.dataset;

    const electionTypeOptions = [
      ...JSON.parse(
        (Boolean(Number(showElectedCandidatesOnly))
          ? electionTypesPostElection
          : electionTypes) as string
      ),
    ].map((e) => ({
      value: e.id,
      label: e.label,
    })) as ElectionType[];

    console.log(electionTypesPostElection, electionTypes);

    const listNameOptions = [...JSON.parse(listNames as string)].map((e) => ({
      value: e.id,
      label: e.label,
      electionTypeId: e.electionTypeId,
    })) as ListName[];

    const selectedElectionType = electionTypeOptions.find(
      (e) => e.value === selectedElectionTypeValue
    ) as ElectionType;

    const selectedListName = listNameOptions.find(
      (e) => e.value === selectedListNameValue
    ) as ListName;

    const copy = {
      candidateListBlockTitle: getTranslations("candidateListBlockTitle"),
      candidateListElectionTypeMenuLabel: getTranslations(
        "candidateListElectionTypeMenuLabel"
      ),
      candidateListElectionTypeMenuLabelPostElection: getTranslations(
        "candidateListElectionTypeMenuLabelPostElection"
      ),
      candidateListElectionTypeMenuPlaceholder: getTranslations(
        "candidateListElectionTypeMenuPlaceholder"
      ),
      candidateListElectionTypeMenuPlaceholderPostElection: getTranslations(
        "candidateListElectionTypeMenuPlaceholderPostElection"
      ),
      candidateListListNameMenuLabel: getTranslations(
        "candidateListListNameMenuLabel"
      ),
      candidateListListNameMenuPlaceholder: getTranslations(
        "candidateListListNameMenuPlaceholder"
      ),
      candidateListHelpText: getTranslations("candidateListHelpText"),
      candidateListHelpTextPostElection: getTranslations("candidateListHelpTextPostElection"),
      candidateListSubstitutes: getTranslations("candidateListSubstitutes"),
      candidateListLoadMore: getTranslations("candidateListLoadMore"),
      candidateListLoadLess: getTranslations("candidateListLoadLess"),
      candidateListNoResults: getTranslations("candidateListNoResults"),
      candidateListNoResultsPostElection: getTranslations(
        "candidateListNoResultsPostElection"
      ),
    };

    render(
      <CandidateList
        copy={copy}
        electionTypes={electionTypeOptions}
        listNames={listNameOptions}
        selectedElectionType={selectedElectionType}
        selectedListName={selectedListName}
        showAllCandidates={Boolean(Number(showAllCandidates))}
        showElectedCandidatesOnly={Boolean(Number(showElectedCandidatesOnly))}
        initialCandidatesList={
          JSON.parse(initialCandidatesList as string) as Candidate[]
        }
      />,
      candidateListContainer
    );
  });
})();
